import clsx from "clsx";
import type { HTMLAttributes } from "react";

import styles from "./empty-state-message.module.css";

export interface EmptyStateMessageProps extends HTMLAttributes<HTMLDivElement> {
  /** Shown when the list or dataset has no rows. */
  message?: string;
}

const DEFAULT_MESSAGE = "No records available";

export const EmptyStateMessage = ({
  message = DEFAULT_MESSAGE,
  className,
  role = "status",
  "aria-live": ariaLive = "polite",
  ...rest
}: EmptyStateMessageProps) => {
  return (
    <div
      className={clsx(styles.wrap, className)}
      role={role}
      aria-live={ariaLive}
      {...rest}
    >
      <p className={styles.text}>{message}</p>
    </div>
  );
};
